import HostFreeAreaService from '@/services/free-area/host-free-area'

export class SelectPaidMembershipPlanFreeArea extends HostFreeAreaService {
  protected get freeAreaPaths(): string[] {
    return [
      'DescriptionToSelectMembershipPlanFreeArea',
    ]
  }
}
